export default {
  code: '404',
  title: 'Page not found',
  description: 'The page you are looking for does not exist or is no longer available.',
};
